import { RefObject, useState, useEffect } from 'react';

export function useGap(tapeRef: RefObject<HTMLElement | null>): number {
    const [gap, setGap] = useState(0);

    useEffect(() => {
        const { current: tape } = tapeRef;
        if (tape === null) {
            return;
        }
        const observer = new ResizeObserver(() => {
            const items = tape.querySelectorAll('.Slider-item');
            if (items.length === 0) {
                setGap(0);
            } else {
                setGap((tape.scrollWidth - (items[0].clientWidth * items.length)) / (items.length - 1));
            }
        });
        observer.observe(tape);
        return (): void => {
            observer.unobserve(tape);
        };
    }, []);

    return gap;
}
